import {useEffect, useLayoutEffect} from "react";

/** `useLayoutEffect` in the browser, `useEffect` on the server, where layout effects never run anyway. */
export const useIsomorphicLayoutEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;
import {useEffect, useLayoutEffect} from "react";

/** `useLayoutEffect` in the browser, `useEffect` on the server, where layout effects never run anyway. */
export const useIsomorphicLayoutEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;
